__turbopack_context__.v({
  "is_active": "NavLink-module-scss-module__CrqL6W__is_active",
  "nav_link": "NavLink-module-scss-module__CrqL6W__nav_link",
});
